import { Observable } from "./Observable.js";
export class AggregatedLoadingObservable extends Observable {
    constructor() {
        super(...arguments);
        this.currentlyLoadingTokens = new Set();
        this.startChildLoading = (token) => {
            if (token === undefined) {
                token = {};
            }
            this.currentlyLoadingTokens.add(token);
            this.doNotifyAll();
            return token;
        };
        this.stopChildLoading = (token) => {
            this.currentlyLoadingTokens.delete(token);
            this.doNotifyAll();
        };
        this.startStopChildLoading = (token, on) => {
            if (on) {
                this.startChildLoading(token);
            }
            else {
                this.stopChildLoading(token);
            }
        };
        this.doNotifyAll = () => this.notifyAll(0 < this.currentlyLoadingTokens.size);
    }
}
